import React from 'react';
import './About.css';

function About() {
  return (
    <section className="about">
      <div>
        <h1>אודות</h1>
        <p>
          נעים להכיר,אני מנחה קבוצות, מחנך ומורה לתקשורת מקרבת, בעל ניסיון עשיר
          בהנחיית מעגלי גברים וקידום תהליכים חינוכיים וחברתיים. אני מתמקד ביצירת
          סביבות למידה תומכות, חיזוק כישורי תקשורת, והקניית כלים להתמודדות עם
          אתגרי חיים וקונפליקטים באמצעות שיטות חדשניות וכלים מעשיים. אני בעל
          תואר ראשון בחינוך עם התמחות בעבודה חברתית, ובוגר תוכניות הכשרה
          בינלאומיות ומקומיות בתחומי תקשורת מקרבת והנחיית קבוצות. אני מביא גישה
          אישית ומקצועית המשלבת אמפתיה, יצירתיות והתמקדות בצרכים הייחודיים של
          משתתפיו.
        </p>
        <h2>הכשרה וניסיון</h2>
        <ul>
          <li>תואר ראשון בחינוך</li>
          <li>מאמן זוגי ומלווה תהליכי צמיחה דרך תקשורת מקרבת</li>
          <li>מנחה סדנאות וקורסים בתקשורת מקרבת</li>
          <li>מנחה מעגלי גברים ומוביל פורום מובילי גברים ארצי</li>
          <li>בוגר תוכנית לימודים שנתית "רקמה" לשינוי חברתי לא אלים</li>
          <li>
            בוגר תוכנית שנתית Non-Violent Communication Global Rising להכשרה
            בינלאומית לתקשורת מקרבת
          </li>
          <li>
            בוגר קורס Convergent Facilitation - הנחייה משלבת וקבלת החלטות בהסכמה
          </li>
          <li>
            בוגר סמינר International Intensive Training 2022 בגרמניה - סמינר
            הכשרה לתקשורת מקרבת לא אלימה
          </li>
          <li>בוגר קורס Culture of Empathy להנחיית מעגלי הקשבה ואמפתיה</li>
          <li>מרכז פרויקטים חינוכיים ומוקדי פעילות בארגוני נוער שונים</li>
          <li>מדריך שנים במרכז ההדרכה "המעורר" לחינוך חברתי לתלמידים ומורים</li>
          <li>
            מדריך במרכז ההדרכה "לגעת בזה" לחינוך מיני מיטיב לתלמידים והכשרות
            למורים וצוותי חינוך
          </li>
          <li>.רכז קהילתי ומדריך של רוג'ום - מעגלי למידה קהילתיים</li>
        </ul>
        <p>
          מוכנים לשינוי? צרו קשר עכשיו והתחילו בתהליך של צמיחה אישית וזוגית
          בעזרת תקשורת מקרבת.
        </p>
      </div>
    </section>
  );
}

export default About;
